import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import Moment from 'moment';
import React from 'react';
import { FaFlag, FaPlus } from 'react-icons/fa';
import { Loading } from 'react-loading-ui';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import './App.css';
import * as constants from './Constants';
import environment from './environments/environment';
import Pagination from './Pagination';
import ReminderModalComponent from './popUpModals/ReminderModalComponent';
import * as ActionType from './redux/actiontypes/ActionType';
import PagerService from './Services/PagerService';

const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer,
        caseDetails: state.caseReducer
    }
}

class CaseSummary extends React.Component {
    constructor() {
        super();
        this.state = {
            show: false,
            caseList: [],
            reDirect: '',
            id: 0,
            caseName: '',
            attorney: '',
            supervisor: '',
            statusFlag: "All",
            status: constants.IS_ACTIVE_YES,
            pageSize: '',
            totalItems: '',
            //pager object
            pager: {},
            // paged items
            pagedItems: [],
            //searchFlag: false,
            caseListCount: '',
            supervisors: [],
            attorneys: [],
            email: '',
            userRole: ''
        }
    }
    componentDidMount = async () => {
        // const timestamp = Date.now(); // This would be the timestamp you want to format
        if (this.props.userStatus.userName !== "") {
            if (Object.keys(this.props.caseDetails).length === 0) {
                this.setState({
                    ...this.state,
                    pageSize: this.toSetPagination(),
                    email: this.props.userStatus.emailId,
                    userRole: this.props.userStatus.userRole,
                    supervisor: this.props.userStatus.userRole === 'Admin' ? '0' : this.props.userStatus.parentId > 0 ? this.props.userStatus.parentId : this.props.userStatus.userId,
                    attorney: this.props.userStatus.userRole === 'Admin' ? '0' : this.props.userStatus.parentId > 0 ? this.props.userStatus.userId : '0'
                }, () => {
                    this.getSupervisors();
                    this.setPage(1);
                })
            } else {
                this.setState({
                    ...this.state,
                    pageSize: this.toSetPagination(),
                    caseName: this.props.caseDetails.caseSearchVo.caseName,
                    email: this.props.userStatus.emailId,
                    userRole: this.props.userStatus.userRole,
                    supervisor: this.props.caseDetails.caseSearchVo.supervisorId,
                    attorney: this.props.caseDetails.caseSearchVo.attorneyId,
                    status: this.props.caseDetails.caseSearchVo.status,
                    statusFlag: this.props.caseDetails.caseSearchVo.statusFlag
                }, () => {
                    this.getSupervisors();
                    this.setPage(1);
                })
            }
        } else {
            this.setState({
                reDirect: '/',
            })
        }
    }

    getSupervisors() {
        axios.get(environment.getAllSupervisors)
            .then(response => {
                if (response.data !== null) {
                    this.setState({
                        ...this.state,
                        supervisors: response.data,
                    }, () => {
                        if (this.state.supervisor > 0) {
                            this.getAttorney(this.state.supervisor);
                        }
                    });
                }
            })
    }

    getAttorney(value) {
        axios.get(environment.getAllAttorneys + value)
            .then(response => {
                if (response.data !== null) {
                    this.setState({
                        attorneys: response.data,
                    });
                }
            })
    }

    changeValue = (e) => {
        if (this.state.userRole === "Admin" && e.target.name === "supervisor" && e.target.value > 0) {
            this.getAttorney(e.target.value)
            this.setState({
                attorney: 0
            })
        } else if (this.state.userRole === "Admin" && e.target.name === "supervisor" && e.target.value === '0') {

            this.setState({
                attorney: 0,
                attorneys: []
            })
        }
        if (e.target.name === 'caseName') {
            this.setState({
                [e.target.name]: e.target.value
            });
        } else {
            this.setState({
                [e.target.name]: e.target.value
            }, () => {
                this.setPage(1);
            })
        }
    }
    search = e => {
        e.preventDefault();
        this.setPage(1);
    };

    clear = e => {
        e.preventDefault();
        if (this.state.userRole === 'Supervisor') {
            this.setState({
                caseName: '',
                attorney: '',
                supervisor: this.state.supervisor,
                statusFlag: "All",
                status: constants.IS_ACTIVE_YES
            }, () => {
                this.setPage(1);
            })
        } else if (this.state.userRole === 'Admin') {
            this.setState({
                caseName: '',
                attorney: 0,
                attorneys: [],
                supervisor: 0,
                statusFlag: "All",
                status: constants.IS_ACTIVE_YES
            }, () => {
                this.setPage(1);
            })
        } else {
            this.setState({
                attorney: this.state.attorney,
                supervisor: this.state.supervisor,
                statusFlag: "All",
                status: constants.IS_ACTIVE_YES
            }, () => {
                this.setPage(1);
            })
        }
    }
    toSetPagination() {
        let pageSize = 0;
        if (localStorage.getItem("listingPageSize") != null &&
            localStorage.getItem("listingPageSize") !== undefined && localStorage.getItem("listingPageSize") !== '0') {
            let tempstr = localStorage.getItem("listingPageSize");
            pageSize = parseInt(tempstr);
        }
        else {
            pageSize = 5;
        }
        return pageSize;
    }

    onPageNoChanged = (pageNo) => {
        this.setPage(pageNo);
    }

    pageSizeChanged = (pageSize) => {
        this.setState({
            pageSize: pageSize
        }, () => {
            this.setPage(1);
            localStorage.setItem('listingPageSize', pageSize);
        })
    }

    setPage(page) {
        this.getCaseInfoList(page);
    }
    getCaseInfoList(page) {
        let casesearch = {};
        casesearch.caseName = this.state.caseName;
        casesearch.attorneyName = this.state.attorney;
        casesearch.supervisor = this.state.supervisor;
        casesearch.attorneyId = this.state.attorney;
        casesearch.supervisorId = this.state.supervisor;
        casesearch.statusFlag = this.state.statusFlag;
        casesearch.status = this.state.status;
        casesearch.mailId = this.state.email;
        casesearch.userRole = this.state.userRole;
        this.props.dispatch({
            type: ActionType.CASEDETAILS, payload: casesearch
        });
        casesearch.pageNo = -1;
        casesearch.pageSize = 0;
        axios.post(environment.getCaseInfoList, casesearch)
            .then(response => {
                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    this.setState({
                        caseList: response.data.caseVOList,
                        caseListCount: response.data.apiResponseVO.recCount
                    }
                        , () => {
                            this.setState({
                                pageSize: this.toSetPagination(),
                                pager: PagerService.getPager(
                                    this.state.caseListCount,
                                    page,
                                    this.state.pageSize
                                ),
                                totalItems: this.state.caseListCount,
                                pagedItems: this.state.caseList.slice(
                                    ((page - 1) * this.state.pageSize), (this.state.pageSize * page)
                                )
                            });
                        });
                } else {
                    this.setState({
                        totalItems: 0,
                        caseList: null,
                        pagedItems: null
                    })
                    // toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER });
                }
            })
            .catch((error) => {
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER });
            });
    }

    onCancelChanges() {
        this.setState({
            reDirect: "/caseSummary"
        })
    }
    onRemindModal() {
        this.setState({ shows: false });
    };
    showRemindModal(event, caseId) {
        event.preventDefault();
        this.setState({
            caseId: caseId,
            shows: true
        });
    };
    onSubmitChanges() {
        this.toReminder();
    }
    toReminder() {
        this.onRemindModal();
        Loading();
        let remainder = {};
        let remainderListVO = {};
        remainder.remainderList = [];
        remainder.mailId = this.state.email;
        remainderListVO.caseId = this.state.caseId;
        remainder.remainderList.push(remainderListVO);
        axios.post(environment.postRemindermail, remainder)
            .then(response => {
                if (response.data.apiResponseVO.type === constants.API_RESPONSE_TYPE_SUCCESS) {
                    //this.setState({ reDirect: '/caseSummary' })
                    setTimeout(() => {
                        Loading();
                    });
                    toast.success(response.data.apiResponseVO.message,
                        { position: toast.POSITION.TOP_CENTER }
                    )
                } else {
                    setTimeout(() => {
                        Loading();
                    });
                    toast.error(response.data.apiResponseVO.message, { position: toast.POSITION.TOP_CENTER })
                }
            })
            .catch((error) => {
                setTimeout(() => {
                    Loading();
                });
                toast.error(error.message, { position: toast.POSITION.TOP_CENTER })
            });
    }
    toCaseDetails(event, caseId) {
        event.preventDefault();
        this.setState({
            caseId: caseId,
            pageName: "CaseSummary",
            reDirect: '/caseDetails'
        })
    }
    toUpdateCase(event, caseId) {
        event.preventDefault();
        this.setState({
            caseId: caseId,
            reDirect: '/newCase'
        })
    }
    render() {
        if (this.state.reDirect) {
            return <Redirect
                to={{
                    pathname: this.state.reDirect, state: {
                        caseId: this.state.caseId,
                        pageName: this.state.pageName,
                    }
                }} />
        }
        return (
            <section style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                <div className="container mt-2 ">

                    <h4>Client Report  Status</h4>

                    <div className="row mb15 mr-2" style={{ marginTop: ' 15px' }}>
                        {this.state.userRole === 'Admin' ? (<div className="col pl-0 pr-0">
                            <label className="col  ">Supervisor</label>&nbsp;
                            <select name="supervisor" value={this.state.supervisor} onChange={this.changeValue}  >
                                <option value='0'>All</option>
                                {this.state.supervisors.map((supervisor) => (
                                    <option key={supervisor.supervisorId} value={supervisor.supervisorId}
                                    >{supervisor.supervisor}</option>
                                ))}
                            </select>
                        </div>) : (<div className="col pl-0 pr-0">
                            <label className="col  ">Supervisor</label>&nbsp;
                            <select disabled name="supervisor" value={this.state.supervisor} onChange={this.changeValue}  >
                                <option value='0'>All</option>
                                {this.state.supervisors.map((supervisor) => (
                                    <option key={supervisor.supervisorId} value={supervisor.supervisorId}
                                    >{supervisor.supervisor}</option>
                                ))}
                            </select>
                        </div>)}
                        {this.state.userRole === 'Supervisor' || this.state.userRole === 'Admin' ? (<div className="col ">
                            <label className="col  pl-0">Attorney </label>&nbsp;
                            <select name="attorney" value={this.state.attorney} onChange={this.changeValue} style={{ width: '60%' }}  >
                                <option value='0'>All</option>
                                {this.state.attorneys.map((attorney) => (
                                    <option key={attorney.attorneyId} value={attorney.attorneyId}
                                    >{attorney.attorneyName}</option>
                                ))}
                            </select>
                        </div>) :
                            (<div className="col ">
                                <label className="col  pl-0">Attorney </label>&nbsp;
                                <select disabled name="attorney" value={this.state.attorney} onChange={this.changeValue}  >
                                    <option value='0' >All</option>
                                    {this.state.attorneys.map((attorney) => (
                                        <option key={attorney.attorneyId} value={attorney.attorneyId}
                                        >{attorney.attorneyName}</option>
                                    ))}
                                </select>
                            </div>)}

                        <div className="col ">
                            <label className="col ">Report Status</label>&nbsp;
                            <select name="statusFlag" value={this.state.statusFlag} onChange={this.changeValue}  >
                                <option selected value="All">All</option>
                                <option value="Grey">No color</option>
                                <option value="Green">Green</option>
                                <option value="Yellow">Yellow</option>
                                <option value="Red">Red</option>
                            </select>
                        </div>
                        <div className="col ">
                            <label className="col ">Status </label>&nbsp;
                            <select name="status" value={this.state.status} onChange={this.changeValue}  >
                                <option selected value="Y">Open</option>
                                <option value="N">Archived</option>
                            </select>
                        </div>
                    </div>
                    <div className="col ">
                        <label className="col">Case Name</label>&nbsp;
                        <input style={{ width: '15%' }} type="text" id="caseName" name="caseName" placeholder="Case Name" value={this.state.caseName} onChange={this.changeValue}></input>
                    </div>
                    <div className="row mb-2 mt-2">
                        <div className="col-md-6 mr-auto text-left">
                            <Link onClick={this.search}><span
                                className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Search</span></Link>
                            <Link onClick={this.clear}><span
                                className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Clear</span> </Link>
                            {/* <Link to="/documents"><span
                                className="btn  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6' }}>Remind all</span> </Link> */}
                        </div>
                        <div className="col-md-6 ml-auto " style={{ textAlign: 'right' }}>
                            {/* <Link ><span className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} > Download</span></Link> */}
                            {this.state.userRole === 'Supervisor' || this.state.userRole === 'Admin' ? (
                                <Link to="/newCase"><span className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >
                                    <FaPlus className="mr-2" ></FaPlus> Case(s)</span></Link>) : (<button type='' disabled className="btn btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >
                                        <FaPlus className="mr-2" ></FaPlus> Case(s) </button>)}
                        </div >
                    </div >

                    <div className="dashboard">
                        <table className="table table-bordered table-condensed table-striped table-hover table-sm" id="table-dashboard">
                            <thead className="color">
                                <tr style={{ borderStyle: 'hidden' }}>
                                    <th  >Case Name </th>
                                    <th >Attorney </th>
                                    <th  >Supervisor</th>
                                    <th style={{ textAlign: 'center' }} >Start Date</th>
                                    <th style={{ textAlign: 'center' }}>Last Report Sent</th>
                                    <th style={{ textAlign: 'center' }} >Next Report Due</th>
                                    <th style={{ textAlign: 'center' }} >Interval</th>
                                    <th style={{ textAlign: 'center' }} >Report Status</th>
                                    <th >Action</th>

                                </tr>
                            </thead>
                            <tbody style={{ borderStyle: 'hidden' }}  >
                                {this.state.pagedItems != null && this.state.pagedItems.map((cases, index) => (
                                    <tr key={index}>
                                        <td><Link onClick={(event) => this.toCaseDetails(event, cases.caseId)}>{cases.caseName}</Link></td>
                                        <td>{cases.attorneyName}</td>
                                        <td >{cases.supervisorName}</td>
                                        <td align="center">{Moment(cases.reportStartDate).format('MM/DD/YYYY')}</td>

                                        {cases.lastReportSent !== null &&
                                            <td align="center">{Moment(cases.lastReportSent).format('MM/DD/YYYY')}</td>
                                        }
                                        {cases.lastReportSent === null &&
                                            <td align="center">-</td>
                                        }
                                        <td align="center" >{Moment(cases.reportDueDate).format('MM/DD/YYYY ')}</td>

                                        <td align="center" >{cases.reportInterval}</td>
                                        {cases.statusFlag === 'Green' && <td align="center" style={{ paddingTop: ' 0.4%' }}><FaFlag style={{ color: 'green' }}></FaFlag> </td>
                                        }
                                        {cases.statusFlag === 'Red' && <td align="center" style={{ paddingTop: ' 0.4%' }}><FaFlag style={{ color: 'red' }}></FaFlag> </td>
                                        }
                                        {cases.statusFlag === 'Yellow' && <td align="center" style={{ paddingTop: ' 0.4%' }}><FaFlag style={{ color: 'yellow' }}></FaFlag> </td>
                                        }
                                        {cases.statusFlag === 'Grey' && <td align="center" style={{ paddingTop: ' 0.4%' }}>  </td>
                                        }
                                        {(this.state.userRole === 'Supervisor' || this.state.userRole === 'Admin') && this.state.status === constants.IS_ACTIVE_YES ? (<div className="dropdown">
                                            <option className="dropdown-toggle" data-toggle="dropdown" >
                                                Select </option>
                                            <ul className="dropdown-menu element" role="menu" style={{ position: 'absolute' }}>
                                                <li>
                                                    <Link onClick={(event) => this.showRemindModal(event, cases.caseId)} className="nav-link link  text-black "  >Remind</Link>
                                                    <Link onClick={(event) => this.toUpdateCase(event, cases.caseId)} className="nav-link link  text-black "  >Edit</Link>
                                                </li>


                                            </ul>
                                        </div>) : (<div className="dropdown" >
                                            <option disabled className="dropdown-toggle" data-toggle="dropdown">
                                                Select </option>
                                            <ul className="dropdown-menu element " role="menu" disabled >
                                                <li className="disabled ">
                                                    <Link onClick={(event) => this.showRemindModal(event, cases.caseId)} className="nav-link link  text-black "  >Remind</Link>
                                                    <Link onClick={(event) => this.toUpdateCase(event, cases.caseId)} className="nav-link link  text-black "  >Edit</Link>

                                                </li>


                                            </ul>
                                        </div>)}
                                    </tr>
                                ))}

                            </tbody>

                        </table>
                    </div>

                    {this.state.totalItems === 0 && <p> No Records are Found.</p>}
                    {this.state.pagedItems !== undefined && this.state.totalItems > 5 && <Pagination pager={this.state.pager} setPage={this.onPageNoChanged} setPageSize={this.pageSizeChanged}></Pagination>}
                    <div className="    ml-5" >
                        <div className='col-1 '><b>Legend :</b>
                        </div>
                        <div className='col-2 ' style={{ paddingLeft: '10px' }}> <FaFlag style={{ color: 'green' }}></FaFlag>&nbsp;: 0-7 Days to Due
                        </div>
                        <div className='col-2 ' style={{ paddingLeft: '10px' }}> <FaFlag style={{ color: 'yellow' }}></FaFlag>&nbsp;: 1-7 Days Past Due
                        </div>
                        <div className='col-2 ' style={{ paddingLeft: '10px' }}> <FaFlag style={{ color: 'red' }}></FaFlag>&nbsp;: 7+ Days Past Due
                        </div>

                    </div>
                    <ToastContainer style={{ marginTop: '7%' }} />
                    <ReminderModalComponent show={this.state.shows} hideModal={() => this.onRemindModal()} submitChanges={() => this.onSubmitChanges()}></ReminderModalComponent>



                </div >
            </section >



        )
    }

}
export default connect(mapStateToProps)(CaseSummary);